__turbopack_context__.v({
  "className": "geist_mono_91d9b7cf-module__Fji20a__className",
  "variable": "geist_mono_91d9b7cf-module__Fji20a__variable",
});
